import "./style.scss";

import React, { FC, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import { UserContext } from "features/account";
import links from "./links";
import { ReactComponent as IconCrown } from "../../assets/img/icons/icon_Lock.svg";
import { DocumentsContext } from "features/documents"; // Import the gold icon

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);


type MenuItemsProps = {
    isCollapsed: boolean;
    forADV?: boolean;
    forSofinco?: boolean;
};

const MenuItems: FC<MenuItemsProps> = ({ isCollapsed, forADV = false, forSofinco = false }) => {
    const { isVerified, userType, user_sub, user } = useContext(UserContext);
    const urlType = userType === "partner" ? "/professionnels/" : "/particuliers/";
    const location = useLocation();

    const {
        notificationsUnseen,
        fetchNotificationsByActions,
        notifications,
    } = useContext(DocumentsContext);

    useEffect(() => {
        if (location.pathname.includes('notifications')) {
            fetchNotificationsByActions('all', 10);
        } else {
            fetchNotificationsByActions('all', 10);
        }
    }, [location.pathname]);

    const filteredLinks = links.filter((link) => {
        if (link?.hideIfnotSub && userType === "individual"){
            return !(user_sub == 0 || user_sub == 1);
        }

        if (link?.hideIfUnverified && userType === "individual") {
            return isVerified;
        }

        if (link?.hideIfADV && forADV){
            return false;
        }

        if (link?.hideIfSofinco && forSofinco){
            return false;
        }

        if (link?.showInMobile && !isMobile){
            return false;
        }

        if (link?.hideInIndividual && userType === "individual") {
            return false;
        }

        if (link?.hideInPartner && userType === "partner") {
            return false;
        }

        if (link?.hideInPartnerMember && userType === "partner" && user?.partnerRole === 'member') {
            return false;
        }

        if (link?.hideIfUnverified && userType === "partner") {
            return !isVerified && userType === "partner";
        }

        return true;
    });

    return (
      <>
          <ul>
              {filteredLinks.map((link, index) => (
                <li
                  key={index}
                  className={location.pathname === `${urlType}${link.url}` ? "active" : ""}>
                    <Link
                      to={urlType + link.url}
                      className="aside__button">
                        <div className="aside__item">
                            {link.icon}
                            {!isCollapsed && (
                              <div className="aside__item-content">
                                  <span>{link.label}</span>
                                  {/*{link?.notFree && (
                                    <IconCrown
                                      className="aside__item-premium"
                                      fill="#FFD700"
                                      width={13}
                                      height={13}
                                    />
                                  )}*/}
                              </div>
                            )}
                            {link.isNotification && (
                              <span
                                className={`rounded-full text-light bg-error-40 ${notificationsUnseen > 9 ? "p-2" : "p-1"} px-3 shadow`}>{notificationsUnseen}</span>

                            )}
                        </div>
                    </Link>
                </li>
              ))}
          </ul>
      </>
    );
};

export default MenuItems;